import { memo, forwardRef } from "react";
import { Card as AntCard } from "antd";
import type { CardProps as AntCardProps } from "antd";
import { cn } from "src/util/cn";

const CustomCard = forwardRef<HTMLDivElement, AntCardProps>(function CustomCard(
  { className, ...props },
  ref
) {
  return (
    <AntCard
      ref={ref}
      className={cn("!bg-white !rounded-xl !border-0", className)}
      {...props}
    />
  );
});

export default memo(CustomCard);
